import { Component, inject, signal, type WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { MessageService } from 'primeng/api';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, type FormControl } from '@angular/forms';
import { finalize } from 'rxjs';
import type { HttpErrorResponse } from '@angular/common/http';

import { InputTextModule } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { MessageModule } from 'primeng/message';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-recover-password',
  imports: [
    InputTextModule,
    FloatLabel,
    ReactiveFormsModule,
    MessageModule,
    ButtonModule
],
  templateUrl: './recover-password.html',
  styleUrl: './recover-password.css'
})
export class RecoverPassword {

  private readonly _fb: FormBuilder = inject(FormBuilder);
  private readonly _router: Router = inject(Router);
  private readonly _authService: AuthService = inject(AuthService);
  private readonly _messageService: MessageService = inject(MessageService);

  public loading: WritableSignal<boolean> = signal<boolean>(false);

  public form: FormGroup = this._fb.group({
    email: [null, [Validators.required, Validators.email]],
  });

  get email(): FormControl {
    return this.form.get('email') as FormControl;
  }

  private _toggleLoading(): void {
    this.loading.update(value => !value);
  }

  public submit(form: FormGroup) {
    if (!form.valid) {
      form.markAllAsDirty();
      return;
    }

    this._toggleLoading();
    this._authService.recoverPassword(form.getRawValue())
      .pipe(finalize(() => this._toggleLoading()))
      .subscribe({
        next: (response) => {
          if (response.success) {
            this._messageService.add({
              severity: 'success',
              summary: response.message,
              life: 3000
            });

            this.goToLogin();
          }
        },
        error: (error: HttpErrorResponse) => {
          this._messageService.add({
            severity: 'error',
            summary: 'Erro ao enviar email de recuperação de senha',
            detail: error.error.message,
            life: 3000
          });
        }
      });
  }

  public goToLogin(): void {
    this._router.navigate(['auth', 'login']);
  }
}
